import * as types from './actionTypes';

export const fetchQuestionsAndAnswersRequest=(params)=>({
    type:types.FETCH_QUESTION_AND_ANSWERS_REQUEST,
    payload:params,
})

export const fetchQuestionsAndAnswersSuccess=(data)=>({
    type:types.FETCH_QUESTION_AND_ANSWERS_SUCCESS,
    payload:data
})

export const fetchQuestionsAndAnswersFailure=(error)=>({
    type:types.FETCH_QUESTION_AND_ANSWERS_FAILURE,
    payload:error
});